import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import AsyncComputed from "vue-async-computed";
import "@/quasar.js";
import router from "@/router.js";
import { store } from "@/store/store.js";
import moment from "moment";
import VueResize from "vue-resize";
import "vue-resize/dist/vue-resize.css";
import { checkPermission } from "@/utils/permissions-validations.js";
import VModal from "vue-js-modal";
import VueParticles from "vue-particles";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

moment.locale("pt-pt");

Vue.config.productionTip = false;
Vue.use(AsyncComputed);
Vue.use(VueRouter);
Vue.use(VueResize);
Vue.use(VModal);
Vue.use(VueParticles);
Vue.mixin({
  methods: {
    can: function () {
      return checkPermission.apply(this, arguments);
    },
  },
});

let apiClient = process.env.VUE_APP_BACKEND_HOST
  ? process.env.VUE_APP_BACKEND_HOST
  : "localhost";

let enviroment = process.env.VUE_APP_ENVIRONMENT
  ? process.env.VUE_APP_ENVIRONMENT
  : "production";

if (enviroment !== "development") {
  Sentry.init({
    Vue,
    environment: process.env.VUE_APP_ENVIRONMENT,
    release: `${process.env.VUE_APP_CLIENT_NAME}@${process.env.VUE_APP_VERSION}`,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [apiClient, /^\//],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    tracesSampleRate: 0.3,
    tracingOptions: {
      trackComponents: true,
    },
    logErrors: true,
    attachProps: true,
    attachStacktrace: true,
  });
}

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
